export default __webpack_public_path__ + "static/media/whitetail@2x.a69be251.jpg";